export default __webpack_public_path__ + "static/media/s3logo.198497a5.webp";